import React, {useEffect, useRef, useState} from 'react';
import * as Icon from "react-feather";

const IconDropdown = ({
                          position = 'list',
                          ready = true,
                          disabled = false,
                          items,
                          onSelect,
                          icon = 'MoreHorizontal',
                          iconSize,
                      }) => {
    const IconComponent = Icon[icon];
    const [isOpen, setIsOpen] = useState(false);

    const dropdownRef = useRef();
    useEffect(() => {
        let handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
    const handleToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    const handleSelect = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        onSelect(item);
        setIsOpen(false);
    };

    return (
        <div className={"sl-relative"} ref={dropdownRef}>
            {position === 'list' && (<button disabled={!ready || disabled}
                                             className={`sl-cursor-pointer sl-w-full sl-flex sl-justify-between sl-align-center sl-gap-2 sl-bg-white sl-p-2 sl-pl-1 sl-pr-1 sl-shadow-xs sl-border sl-border-solid sl-border-gray-300 sl-rounded-lg sl-rounded-lg ${isOpen ? 'active' : ''}`}
                                             onClick={handleToggle}>
                <IconComponent className={'sl-m-auto'} size={iconSize ? iconSize : 24}/>
            </button>)}


            {position === 'top' && (<button disabled={!ready || disabled}
                                            className={"sl-cursor-pointer sl-btn-clear sl-rounded-lg sl-p-2"}
                                            onClick={handleToggle}>
                <IconComponent color={"#667085"} className={'sl-m-auto'} size={iconSize ? iconSize : 24}/>
            </button>)}


            {isOpen && (
                <div
                    className="select-options sl-flex sl-flex-col sl-w-55 sl-absolute sl-top-10 sl-right-0 sl-shadow-lg sl-bg-white sl-border sl-border-solid sl-border-gray-100 sl-rounded-lg">
                    {items.map((item, index) => {
                        return <div
                            key={index}
                            rel={item.key}
                            className="sl-flex sl-text-gray-900 sl-py-10 sl-px-14 flex-row sl-gap-2 sl-cursor-pointer sl-justify-start sl-align-center sl-hover-gray-50"
                            onClick={(e) => handleSelect(e, item)}>
                            {item.icon}
                            <span>{item.text}</span>
                        </div>
                    })}
                </div>
            )}
        </div>
    );
};

export default IconDropdown;
